<template>
  <div>
    <div class="box-content">
      <p
        class="Fuell-Text"
        v-t="{path:'company_integrations_settings_information'}"
      ></p>
    </div>
    <div class="integrations-card-container">
      <integration-card-box
        v-for="erpItem in erpConfigItems"
        :key="erpItem.id"
        :integrationData="erpItem"
      ></integration-card-box>
      <div
        class="Fuell-Card Fuell-Card--integration"
        @click="openSuggestion"
      >
        <div
          class="Thumb Thumb--32"
          style="flex: 0 0 26px"
        >
          <img
            :src="helpIcon"
            alt="help-icon"
          />
        </div>
        <div class="d-flex flex-column ml-3">
          <span
            class="Fuell-Card--integration-title align-self-start"
            v-t="{path:'company_integrations_suggest_integration'}"
          ></span>
          <small
            class="Fuell-Card--integration--small"
            v-t="{path:'company_integrations_suggest_integration_comment'}"
          ></small>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import IntegrationCardBox from '../../_components/integrations_details/IntegrationCardBox.vue'
import { erpConfigItems } from '../../_utils/IntegrationsConfigData'
import HelpIcon from '@/assets/img/icons/help-circle.svg'
export default {
  name: 'IntegrationsIndex',
  components: { IntegrationCardBox },
  computed: {
    erpConfigItems () {
      return erpConfigItems
    },
    helpIcon () {
      return HelpIcon
    }
  },
  methods: {
    async openSuggestion () {
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open()
      }
    }
  }
}
</script>

<style scoped>
.integrations-card-container {
  display: flex;
}
@media screen and (max-width: 576px) {
  .integrations-card-container {
    flex-direction: column;
    align-items: center;
  }
  .Fuell-Card--integration {
    max-height: 100px;
  }
}
</style>
